import { render, staticRenderFns } from "./CategoryNav.vue?vue&type=template&id=7925af9a&scoped=true&"
import script from "./CategoryNav.vue?vue&type=script&lang=js&"
export * from "./CategoryNav.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNav.vue?vue&type=style&index=0&id=7925af9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7925af9a",
  null
  
)

export default component.exports